import queryString from 'query-string';
import { Environment, env } from './environment';

// The base domain of DRYCUT (landing page)
const HomeUrls: Record<Environment, string> = {
  development: 'http://localhost:4001',
  production: 'https://www.drycut.ch',
  staging: 'https://staging-booking.drycut.ch',
};

const GraphApiUrls: Record<Environment, string> = {
  development: 'http://localhost:3000/graphql',
  production: 'https://api.drycut.ch/graphql',
  staging: 'https://staging-api.drycut.ch/graphql',
};

const AdminApiUrls: Record<Environment, string> = {
  development: 'http://localhost:3000/admin',
  production: 'https://api.drycut.ch/admin',
  staging: 'https://staging-api.drycut.ch/admin',
};

const BookingUrls: Record<Environment, string> = {
  development: 'http://localhost:4001', // same url as home but can be a different app running
  production: 'https://booking.drycut.ch',
  staging: 'https://staging-booking.drycut.ch',
};

const ReferralUrls: Record<Environment, string> = {
  development: 'http://localhost:3501', // same url as home but can be a different app running
  production: 'https://rf.drycut.ch',
  staging: 'https://staging-rf.drycut.ch',
};

const GraphApiSocketUris: Record<Environment, string> = {
  development: 'ws://localhost:3000/cable',
  production: 'wss://api.drycut.ch/cable',
  staging: 'wss://staging-api.drycut.ch/cable',
};

const TermsAndConditionsUrl = `${HomeUrls['production']}/terms-and-conditions`;

const CutNowURL = (coupon: string | null = null) => {
  const href = queryString.stringifyUrl({
    url: Navigation.HOME_URL,
    query: { coupon: coupon ?? undefined },
    fragmentIdentifier: 'stores-section',
  });

  return href;
};

// This is the main object that can be used by all the apps and libraries to get the URLs of the
// whole system.
export const Navigation = {
  BASE_URL: import.meta.env.BASE_URL, // determined by the base config option
  HOME_URL: HomeUrls[env],
  GRAPH_API_URL: GraphApiUrls[env],
  GRAPH_API_WS_URI: GraphApiSocketUris[env],
  ADMIN_API_URL: AdminApiUrls[env],
  CUT_NOW_URL: CutNowURL,
  BOOKING_URL: BookingUrls[env],
  REFERRAL_URL: ReferralUrls[env],
  TERMS_AND_CONDITIONS: TermsAndConditionsUrl,
};
